import * as Security from './archibus/SecurityApi'

export const logon = async ({username, password, project = null}) => {
  const projects = await Security.getProjects()

  if (!project) {
    project = projects[0].id
  }
  await Security.logout()
  await Security.login(username, password, project, 'en-US')
}
